import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { Link, Stack, Tooltip } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { Chat } from "../chat/type";

export default function ChatDetailButton(props: GridCellParams<Chat, any>) {
  const { id, hospitalId } = props.row;
  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={{ alignItems: "center", height: "100%" }}
    >
      <Link component={RouterLink} to={`/chats/${id}`}>
        Detay
      </Link>
      <Tooltip title="Yazışmada bu mesajın geçtiği yere git">
        <Link
          component={RouterLink}
          to={`/chats/conversation/${hospitalId}?focus=${id}`}
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
        >
          <ForumOutlinedIcon fontSize="small" />
          Yazışma
        </Link>
      </Tooltip>
    </Stack>
  );
}
